import { render, staticRenderFns } from "./explanation.vue?vue&type=template&id=7633b4aa&scoped=true&"
import script from "./explanation.vue?vue&type=script&lang=js&"
export * from "./explanation.vue?vue&type=script&lang=js&"
import style0 from "./explanation.vue?vue&type=style&index=0&id=7633b4aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633b4aa",
  null
  
)

export default component.exports